module.exports = __webpack_public_path__ + "static/media/cover_template3.6d6dfd3e.jpg";